import { render, staticRenderFns } from "./DevApps.vue?vue&type=template&id=27742be2"
import script from "./DevApps.vue?vue&type=script&lang=ts"
export * from "./DevApps.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports